import { useMutation } from '@apollo/client';
import {
  QuizAnswers,
  SaveUserDataMutationDocument,
} from 'src/generated/graphql';
import { InputsReducer } from 'src/redux/reducers/inputs';
import { client } from 'src/utils/apollo-client';
import { getQuizAnswers } from 'src/utils/inputs';

export const useSaveUserData = () => {
  const [mutate, { error }] = useMutation(SaveUserDataMutationDocument, {
    client,
  });

  if (error) {
    console.error(error);
  }

  return async (inputs: InputsReducer) => {
    try {
      const result = await mutate({
        variables: { inputs: getQuizAnswers(inputs) as QuizAnswers },
      });
      return result?.data?.cardFinderUserData ?? false;
    } catch (e) {
      console.error(e);
    }

    return false;
  };
};
